export const place = { id: "pedidos", path: "/pedidos" } as const;
